import type { PageStoryblok, ReusableStoryblok } from "@/generated/sb/sb-types";
import type { SbBlokData } from "@storyblok/react/rsc";
import { storyblokEditable } from "@storyblok/react/rsc";

import { BlokProps, StoryblokComponentList } from "@frend-digital/storyblok";
import clsx from "clsx";

const Page = ({
  blok,
  preview,
}: BlokProps<PageStoryblok | ReusableStoryblok>) => {
  if (!blok.body) return <p> Missing body in blok: Page</p>;

  return (
    <div
      {...storyblokEditable(blok as unknown as SbBlokData)}
      className={clsx(
        "page-blok",
        blok?.template === "simple" && "layout-simple",
      )}
    >
      <StoryblokComponentList bloks={blok?.body} preview={preview} />
    </div>
  );
};

export default Page;
